import React, { Component } from 'react';
import { Container, Col, Row, Toast, ToastContainer } from 'react-bootstrap';
import { CustomToast } from './CustomToast'
import '../css/NotificationsDesk.css'


import { setupSignalRConnection } from './SignalRConnection';

import { setUserData } from './redux/currentUserSlice'
import { useSelector, useDispatch } from 'react-redux'
import { decrement, increment } from './redux/counterSlice'
import { addNotifications } from './redux/notificationSlice'





class NotificationsDesk extends Component {


    constructor(props) {
        super(props);


        /*this.addToast = this.addToast.bind(this);*/
        this.state = { toasts: [{ id: Math.random(), Component: CustomToast }], val: 5 }
    }

    


    /*addToast() {

        this.setState({ toasts: [...this.state.toasts, { id: Math.random(), Component: CustomToast }]  });
        *//*const state = this.state;*//*
        //redux
        this.props.dispatch(addNotifications({cos: "cos"}));
        this.props.dispatch(setUserData({res: "5"}));

    }*/

    render() {


        return (

            <div className="d-flex flex-column flex-grow-1 border rounded-3 shadow-sm bg-white m-2 p-0" >

                <div className="border-bottom py-1"><p className="h6 text-secondary m-0 p-0 text-center font-weight-600 lh-1 py-1"><i className="bi bi-bell pe-2"></i>Powiadomienia</p></div>
                <div className="d-flex flex-grow-1 overflow-auto scroll-grow-path bg-custom-surface-secondary rounded-bottom">
                   
                    <div className="d-flex flex-column align-items-stretch">
                        {

                            this.state.toasts.map(({ Component, id }) => (
                                <Component key = { id } />
                            ))
                        }
                    </div>
                </div>
            </div>

            
            
        );
    }
};

function withMyHook(Component) {
    return function WrappedComponent(props) {

        const count = useSelector((state) => state.counter.value);
        const dispatch = useDispatch();

        return <Component {...props} count={count} dispatch={dispatch} />;
    }
}


export default withMyHook(NotificationsDesk)